import React from 'react'
import { FiMapPin } from 'react-icons/fi'

export const PersonItem = ({item}) => {

    return (
        <li className="flex">
            <div className="flex-start">
                <div><img src={item.avatar} className="avatar" alt="" /></div>
                <div>
                    <h4 className="name">{item.name}</h4>
                    <p className="place"><FiMapPin /> {item.place}</p>
                </div>
            </div>
            <div className="button">
                <p className={`${item.followed ? 'active':'' }`}>{item.followed ? 'Following' : 'Follow'}</p>
            </div>
        </li>
    )
} 
